import React from 'react';
import { Form, InputNumber, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { UNIT_PRICE_INPUT_PROPS } from '../../utils/money';
import { POLISH_DECIMAL_INPUT_NUMBER_PROPS } from '../../utils/transportCostAllocation';
import { formatUnit } from '../../utils/units';

export default function AveragePurchasePriceFields({ disabled }: { disabled: boolean }) {
  const { t } = useTranslation('products');
  return <Form.Item label={t('fields.averagePurchasePricePLN')} tooltip={t('fields.averagePurchaseHelp')}>
    <div className="product-price-pair">
    <Form.Item name="averagePurchasePricePLN" noStyle>
      <InputNumber aria-label={t('fields.averagePurchasePricePLN')} {...UNIT_PRICE_INPUT_PROPS} {...POLISH_DECIMAL_INPUT_NUMBER_PROPS} min={0} max={99999999.9999} disabled={disabled} controls={false} />
    </Form.Item>
    <Form.Item name="averagePurchasePriceUnit" noStyle
      dependencies={['averagePurchasePricePLN']} rules={[({ getFieldValue }) => ({
        validator(_, unit) {
          return getFieldValue('averagePurchasePricePLN') == null || unit
            ? Promise.resolve() : Promise.reject(new Error(t('fields.averagePurchaseUnitRequired')));
        },
      })]}>
      <Select aria-label={t('fields.averagePurchasePriceUnit')} placeholder={t('fields.averagePurchasePriceUnit')} disabled={disabled} allowClear options={(['pcs', 'm2', 'm3'] as const).map(unit => ({
        value: unit, label: formatUnit(unit, 'pl'),
      }))} />
    </Form.Item>
    </div>
  </Form.Item>;
}
